// 交通手段・区間 section — header, note, bulk actions, leg list, total.
import { ArrowSquareOut, Plus, Copy, Trash } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { TransportLegCard } from './TransportLegCard';

export const TransportLegsSection = ({
  legs, selectedIds, isMultiDay, travelStartDate, travelEndDate, uploadingLegId,
  transportationFee, onAdd, onBulkCopy, onBulkDelete, onClearSelection,
  onToggleSelect, onCopy, onRemove, onUpdate, onReceiptUpload, onReceiptRemove,
}) => (
  <div className="rounded-lg border border-zinc-200 bg-zinc-50/40 p-5 sm:p-6 space-y-3">
    <div className="flex items-center justify-between flex-wrap gap-2">
      <div className="flex items-center gap-2">
        <div className="h-7 w-1 rounded-full bg-teal-700" />
        <h3 className="text-sm font-bold uppercase tracking-wider text-zinc-700">交通手段・区間 *</h3>
      </div>
      <div className="flex items-center gap-2">
        <a
          href="https://transit.yahoo.co.jp/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="link-yahoo-manual"
          className="inline-flex items-center gap-1 text-xs font-medium text-teal-700 hover:text-[#0040CC] hover:underline"
        >
          Yahoo!路線情報 <ArrowSquareOut size={11} />
        </a>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onAdd}
          data-testid="btn-add-leg"
          className="border-[#B3CBFF] text-teal-700 hover:bg-[#E5EDFF] hover:border-teal-700"
        >
          <Plus size={14} className="mr-1" /> 区間を追加
        </Button>
      </div>
    </div>
    <div className="rounded-md bg-white/60 border border-zinc-200 px-3 py-2 text-xs text-zinc-600 leading-relaxed">
      <p>
        <span className="text-amber-700 font-semibold">※</span> 運賃は <strong className="text-zinc-900">現金優先（きっぷ通常運賃）</strong> を入力してください。ICカード料金ではありません。
      </p>
      {isMultiDay && (
        <p className="mt-1 text-teal-700 font-medium">
          複数日出張のため、往路・復路・現地移動を分けて入力してください。
        </p>
      )}
    </div>

    {/* Bulk action bar — appears when 1+ legs selected */}
    {selectedIds.length > 0 && (
      <div
        data-testid="leg-bulk-bar"
        className="mb-3 flex flex-wrap items-center gap-2 rounded-md bg-blue-50 border border-blue-200 px-3 py-2"
      >
        <span className="text-xs font-medium text-blue-900">{selectedIds.length} 件選択中:</span>
        <Button
          type="button"
          size="sm"
          onClick={onBulkCopy}
          data-testid="leg-bulk-copy"
          className="h-7 bg-teal-700 hover:bg-teal-800 text-white"
        >
          <Copy size={13} className="mr-1" /> 複製
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={onBulkDelete}
          data-testid="leg-bulk-delete"
          className="h-7 bg-white text-red-700 border-red-300 hover:bg-red-50"
        >
          <Trash size={13} className="mr-1" /> 削除
        </Button>
        <button
          type="button"
          onClick={onClearSelection}
          data-testid="leg-bulk-clear"
          className="ml-auto text-xs text-blue-700 hover:underline"
        >
          選択解除
        </button>
      </div>
    )}

    <div className="space-y-2">
      {legs.map((leg, idx) => (
        <TransportLegCard
          key={leg.id}
          leg={leg}
          idx={idx}
          isSelected={selectedIds.includes(leg.id)}
          canRemove={legs.length > 1}
          travelStartDate={travelStartDate}
          travelEndDate={travelEndDate}
          uploading={uploadingLegId === leg.id}
          onToggleSelect={() => onToggleSelect(leg.id)}
          onCopy={() => onCopy(leg.id)}
          onRemove={() => onRemove(leg.id)}
          onUpdate={(patch) => onUpdate(leg.id, patch)}
          onReceiptUpload={(e) => onReceiptUpload(leg.id, e)}
          onReceiptRemove={(receiptId) => onReceiptRemove(leg.id, receiptId)}
        />
      ))}
    </div>

    <div className="mt-3 flex justify-end items-baseline gap-2 text-sm font-medium text-zinc-600">
      <span className="uppercase tracking-wider text-xs">交通費合計</span>
      <span className="text-lg text-teal-700 font-bold tabular-nums">¥{transportationFee.toLocaleString()}</span>
    </div>
  </div>
);
